import React, {useState} from 'react';

const AdminFreeFetchInput = () => {

    const [data, setData] = useState('');
    const [fetchTime, setFetchTime] = useState('');
    const [inputValue, setInputValue] = useState('');

    const handleSend = async () => {
        setFetchTime('');
        try {
            const response = await fetch(inputValue);
            const responseText = await response.text();
            const endTime = new Date();
            setData(responseText);
            setFetchTime(`Fetch completed at: ${endTime.toLocaleTimeString()}`);
        } catch (e) {
            setData(`Error: ${e.message}`);
        }
    };

    return (
        <div style={{border: '1px solid #ccc', padding: '10px'}}>
            <h2>Freestyle fetch</h2>
            <input
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        handleSend();
                    }
                }}
                placeholder="Enter URL"
                style={{marginRight: '10px', width: '60%'}}
            />
            <button onClick={handleSend}>Send</button>

            {fetchTime && <p>{fetchTime}</p>}
            <textarea
                value={data}
                readOnly
                rows={10}
                style={{marginTop: '10px', resize: 'none', width: '100%'}}
            />
        </div>
    );
};

export default AdminFreeFetchInput;
